module.exports = __webpack_public_path__ + "7d088296/img/document.e2130c6b.svg";